import React from 'react';
import { usePermissions } from 'react-admin';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { PANEL_LOGIN_ROLE_IDS } from '../constants/croles';

/**
 * UI kapısı: API yetki kontrolünün yerine geçmez.
 * allow verilmezse panel girişine izinli bütün roller kabul edilir.
 */
const RequireAuth = ({ children, allow = [] }) => {
  const { permissions, isLoading } = usePermissions();
  const location = useLocation();

  if (isLoading) {
    return (
      <Box
        data-testid="require-auth-loading"
        sx={{ display: 'flex', justifyContent: 'center', py: 6 }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!permissions?.crole) {
    return <Navigate to="/login" replace state={{ nextPathname: location.pathname }} />;
  }

  const allowedRoles = allow.length ? allow : PANEL_LOGIN_ROLE_IDS;
  if (!allowedRoles.includes(permissions.crole)) {
    return (
      <Box data-testid="require-auth-forbidden" sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom>
          403
        </Typography>
        <Typography>Bu sayfayı görüntüleme yetkiniz yok.</Typography>
      </Box>
    );
  }

  return children;
};

export default RequireAuth;
